import { useState } from 'react';

const messageTypes = {
    connect: 'MESSAGE_CONNECT',
    enter: 'MESSAGE_ENTER',
    users: 'MESSAGE_USERS',
    leave: 'MESSAGE_LEAVE',
    ping: 'MESSAGE_PING',
    error: 'MESSAGE_ERROR',
    data: 'MESSAGE_DATA'
}

const loginMessage = (table, name, color, email) => JSON.stringify({type:messageTypes.enter, table, name, color, email});
const leaveMessage = (table, name, color, email) => JSON.stringify({type:messageTypes.leave, table, name, color, email});
const dataMessage = (table, name, color, email, to, id, data) => {
    let m = {type:messageTypes.data, table, name, color, email, to, id, data};
    return JSON.stringify(m);
};
const pingMessage = (table, email) => JSON.stringify({type:messageTypes.ping, table, email});

let ws = undefined;
let connectionId = "";
let tableId = "";
let user = "";
let color = "";
let email = "";
let heartbeat = undefined;
let reconnect = undefined;

const connect = (callbacks) => {
    if (ws) {
        return false;
    }

    try {
        ws = new WebSocket(`${process.env.REACT_APP_WS_HOST}`);
        
        ws.onopen = () => {
            heartbeat && clearInterval(heartbeat);
            reconnect && clearInterval(reconnect);

            if (!ws || ws.readyState !== WebSocket.OPEN) return;

            ws.send(loginMessage(tableId, user, color, email));
            callbacks.onReceiveUserEnter(callbacks.user);
            if (callbacks.onChangeOnlineStatus) {
                callbacks.onChangeOnlineStatus(true);
            }
        };;

        ws.onclose = () => {
            heartbeat && clearInterval(heartbeat);
            reconnect && clearInterval(reconnect);
            ws = undefined;

            if (callbacks.onChangeOnlineStatus) {
                callbacks.onChangeOnlineStatus(false);
            }

            reconnect = setInterval(() => {
                console.log('Reconnecting...');
                open(callbacks);
            }, 1000);
        };

        ws.onerror = (e) => {
            console.error(e);
            if (callbacks.onChangeOnlineStatus) {
                callbacks.onChangeOnlineStatus(false);
            }
            open(callbacks);
        };

        ws.onmessage = (e) => {
            let data = JSON.parse(e.data);

            switch(data.type) {
                case messageTypes.users:
                    callbacks.onReceiveUsers(data.users);
                    break;

                case messageTypes.data:
                    callbacks.onReceiveData(data.data);
                    break;

                case messageTypes.leave:
                    callbacks.onReceiveUserLeave(data);
                    break;

                case messageTypes.error:
                    console.warn(data);
                    break;

                case messageTypes.connect:
                    connectionId = data.id;
                    break;

                default:
                    break;
            }
        };

        return true;
    } catch (e) {
        return false;
    }
}

const open = (callbacks) => {
    if (connect(callbacks)) {
        heartbeat = setInterval(() => {
            if (!ws) return;
            if (ws.readyState === 1) {
                ws.send(pingMessage(tableId, email))
            }
        }, 50000);
    }
}

const update = (u) => {
    let prevTableId = tableId;
    tableId = u.tableId ?? '0';
    user = u.user;
    color = u.color;
    email = u.email;

    let retrySend = setInterval(()=>{
        if (ws && ws.readyState === 1) {
            clearInterval(retrySend);
            ws.send(leaveMessage(prevTableId, u.user, u.color, u.email));
            ws.send(loginMessage(u.tableId, u.user, u.color, u.email));
        }
    },200);
}

const send = (data, to) => {
    try {
        if (!ws || ws.readyState !== 1) {
            return false;
        }

        ws.send(dataMessage(
            tableId, 
            user, 
            color, 
            email, 
            to ?? null,
            connectionId,
            data
        ));

        return true;
    } catch (e) {
        console.log(e);
        return false;
    }
}

const close = () => {
    if (ws) {
        ws.close();
        clearInterval(heartbeat);
        heartbeat = undefined;
        ws = undefined;
    }
}


export const useWebSocket = () => {

    const [isOnline, setIsOnline] = useState(false);

    return {
        connect: (callbacks) => {
            callbacks.onChangeOnlineStatus = setIsOnline;
            open(callbacks);
        },
        update: (u) => {
            update(u);
        },
        send: (data, to) => {
            return send(data, to);
        },
        close: () => {
            setIsOnline(false);
            close();
        },
        isOnline
    }

}